import register from '@kpsys/angularjs-register';

import loginComponentModule from './kp-login/kp-login.module';

import LoginService from './login.service';
import MainLoginFormService from './main-login-form-service';
import RegistrationService from './registration.service';
import {AuthPairingService} from './account-pairing-modal/auth-pairing.service';

export default register('portaro.shared.login', [loginComponentModule])
    .service(MainLoginFormService.serviceName, MainLoginFormService)
    .service(LoginService.serviceName, LoginService)
    .service(RegistrationService.serviceName, RegistrationService)
    .service(AuthPairingService.serviceName, AuthPairingService)
    .name();
